import React, { useState, useEffect, useRef } from "react";
import styles from "./Tables.module.css";
import { useDispatch, useSelector } from "react-redux";
import optionDots from "../../assets/optionDots.svg";
import emptyImage from "../../assets/ImageEmpty.svg";
import AmountTransaction from "../../components/AmountTransaction/AmountTransaction";
import OptionsSwitchComponent from "../../components/OptionsSwichComponent/OptionsSwitchComponent";
import { useTranslation } from "react-i18next";
import {
  createTable,
  createTableData,
  createVariable,
  deleteRowTable,
  deleteTable,
  getTableById,
  getTableData,
  getTableDataFiltered,
  getTables,
  getTablesWithCounts,
  getVariable,
  refreshTableInfo,
  updateTableName,
  updateTableType,
} from "../../../../actions/user";
import Button from "../../components/Button/Button";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import NewContact from "../../components/NewContact/NewContact";
import NewAsset from "../../components/NewAsset/NewAsset";
import NewBIll from "../../components/NewBIll/NewBIll";
import CreateParameterPopup from "../../components/CreateParameterPopup/CreateParameterPopup";
import ClientsHeader from "../../components/ClientsHeader/ClientsHeader";
import PaginationTables from "../../components/PaginationTables/PaginationTables";
import FiltersDropdownContainer from "../../components/FiltersDropdownContainer/FiltersDropdownContainer";
import OptionsPopup from "../../components/OptionsPopup/OptionsPopup";
import imageEmpty from "../../assets/ImageEmpty.svg";
import { ReactComponent as PencilEdit } from "../../assets/pencilEdit.svg";
import { ReactComponent as HorizontalDots } from "../../assets/S3/horizontalDots.svg";
import { ReactComponent as IconContact } from "../../components/HomeExplorer/assets/icon-contact.svg";
import { ReactComponent as IconDocument } from "../../components/HomeExplorer/assets/icon-document.svg";
import { ReactComponent as IconTables } from "../../components/HomeExplorer/assets/icon-tables.svg";
import { ReactComponent as IconAsset } from "../../components/HomeExplorer/assets/icon-asset.svg";
import { ReactComponent as TableLockClose } from "../../assets/tableLockClose.svg";
import { ReactComponent as TableLockOpen } from "../../assets/tableLockOpen.svg";
import SelectAgentModal from "../ChatView/SelectAgentModal/SelectAgentModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { setContact, setContactTableId, setFatherNewContact } from "../../../../slices/contactsSlices";
import { setPaginationSlice } from "../../../../slices/paginationSlices";
import { setContactsTableLength, setFirstTimeContacts, setFatherNewBill, setCurrentTableNew } from "../../../../slices/userSlices";
import { setAsset, setFatherNewAsset } from "../../../../slices/assetsSlices";
import { formatAgoDate } from "../../../../utils/agoDateUtil";
import { getAllContacts } from "../../../../actions/contacts";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
const Tables = () => {
  const dispatch = useDispatch();
  // const [tables, setTables] = useState([]);
  // const [tableDataMap, setTableDataMap] = useState({});
  const { t } = useTranslation(["Contacts","Assets"]);
  const dynamicTableRef = useRef(null);
  const [contactSelected, setContactSelected] = useState([]);
  const [documentSelected, setDocumentSelected] = useState([])
  const [activeSelectIndex, setActiveSelectIndex] = useState(null);
  const [showNewContact, setShowNewContact] = useState(false);
  const [activeTable, setActiveTable] = useState(null);
  const [newAsset, setShowNewAsset] = useState(false);
  const [showAddTags, setShowAddTags] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [showNewBill, setShowNewBill] = useState(false);
  const [editingTableId, setEditingTableId] = useState(null);
  const [editedTableName, setEditedTableName] = useState("");
  const selectRef = useRef(null);
  const { tables, tableDataMap, totalPaginationTables,currentTableNew } = useSelector((state) => state.user);
  const { user, tableView, contactsTableLength, firstTimeContact,assetsTableLength, firstTimeAssets,docsTableLength, firstTimeDocs } = useSelector((state) => state.user);
  const navigate = useNavigate()
  const { id } = useParams()
     const popupButtonRef = useRef([]);
     const longPressTriggeredRef = useRef(false);
     const timerRef = useRef(null);
   const { contactLimitSlice, contactPageSlice } = useSelector(
    (state) => state.pagination
  );
  const [currentTableId, setCurrentTableId] = useState(null)
  const [currentTableType, setCurrentTableType] = useState(null)
  const [showPopupNewContact,setShowPopupNewContact] = useState(false)
   const [showPopup, setShowPopup] = useState(false)
   const [showPopupNewAsset, setShowPopupNewAsset] = useState(false)
   const [showPopupNewTransaction, setShowPopupNewTransaction] = useState(false);
   const [docSelected, setDocSelected] = useState(false);

    const [limit, setLimit] = useState(20);
    const [page, setPage] = useState(0);
    const location = useLocation()
    const searchInputRef = useRef(null)
    const [searchTerm, setSearchTerm] = useState("")
    const [isChecked,setIsChecked] = useState(false)
    const [isChecked2,setIsChecked2] = useState(true)

    const [selectedOption, setSelectedOption] = useState({
        "Orden Alfabético": "A-Z", 
        Estado: "Todos", 
        "Moneda Preferida": "USD", 
        "# Transacciones": "Mayor a menos", 
        "Ingresos/Costes": "Ingresos de mayor a menor", 
      });
    
      const options = [
        {
          name: "Orden Alfabético",
          label: t("alphabeticOrder"),
          subOptions: [
            { display: "A-Z", value: "A-Z" },
            { display: "Z-A", value: "Z-A" },
          ],
        },
        {
          name: "Estado",
          label: t("status"),
          subOptions: [
            { display: t("all"), value: "Todos" },
            { display: t("approved"), value: "Aprobados" },
            { display: t("notApproved"), value: "No aprobados" },
            { display: t("paid"), value: "Pagados" },
            { display: t("pending"), value: "Pendiente" },
            { display: t("defaulted"), value: "Incumplidos" },
            { display: t("expired"), value: "Vencido" },
            { display: t("cancelled"), value: "Anulados" },
          ],
        },
        {
          name: "Moneda Preferida",
          label: t("preferredCurrency"),
          subOptions: "currencies",
        },
        {
          name: "# Transacciones",
          label: t("transactions"),
          subOptions: [
            { display: t("higherToLower"), value: "Mayor a menos" },
            { display: t("lowerToHigher"), value: "Menor a mayor" },
          ],
        },
        {
          name: "Ingresos/Costes",
          label: t("incomeCosts"),
          subOptions: [
            {
              display: t("incomeHigherToLower"),
              value: "Ingresos de mayor a menor",
            },
            {
              display: t("incomeLowerToHigher"),
              value: "Ingresos de menor a mayor",
            },
            { display: t("costsHigherToLower"), value: "Costes de mayor a menor" },
            { display: t("costsLowerToHigher"), value: "Costes de menor a mayor" },
          ],
        },
        {
          name: "dateFilter",
          label: t("dateFilter"),
          subOptions: [
            { display: t('1month'), value: "1month" },
            { display: t('3month'), value: "3month" },
            { display: t('6month'), value: "6month" },
            { display: t('1year'), value: "1year" },
    
          ],
        },
        {
          name: "dateOrder",
          label: t("dateOrder"),
          subOptions: [
            { display: t('ascendant'), value: "ascendant" },
            { display: t('falling'), value: "falling" },
          ],
        },
      ];

  // console.log('id', id)
  // console.log('esto es tableView',tableView)

  // console.log('esto es tabledataMap', tableDataMap)

  const headersTable = [
    {
      label: "Nombre",
      key: "contactName",
      type:"textBox"
    },
    {
      label: "Correo",
      key: "companyEmail",
      type:"email"
    },
    {
      label: "Teléfono",
      key: "companyPhoneNumber",
      type:"number"
    },
    {
      label: "Dirección Física",
      key: "companyAddress",
      type:"textBox"
    },
    {
      label: "Número Fiscal",
      key: "taxNumber",
       type:"number"
    },
    {
      label: "Métodos de Pago",
      key: "cardNumber",
       type:"number"
    },
    {
      label: "Moneda Preferida",
      key: "preferredCurrency",
      type:"textBox"
    },
    {
      label: "Desde",
      key: "createdAt",
       type:"date"
    },
    {
      label: "transacciones",
      key: "transactions",
       type:"number"
    },
  ];

  const headersByType = {
    contacts: [
      {
        label: "Nombre",
        key: "contactName",
         type:"contact"
      },
      {
        label: "Correo",
        key: "companyEmail",
         type:"email"
      },
      {
        label: "Teléfono",
        key: "companyPhoneNumber",
         type:"phone"
      },
      {
        label: "Dirección Física",
        key: "companyAddress",
         type:"location"
      },
      {
        label: "Número Fiscal",
        key: "taxNumber",
         type:"number"
      },
      {
        label: "Métodos de Pago",
        key: "cardNumber",
         type:"number"
      },
      {
        label: "Moneda Preferida",
        key: "preferredCurrency",
         type:"textBox"
      },
      {
        label: "Desde",
        key: "createdAt",
         type:"date"
      },
      {
        label: "transacciones",
        key: "transactions",
         type:"number"
      },
    ],
    assets: [
      {
        label: "Código",
        key: "code",
        type:"number"
      },
      {
        label: "Nombre o Descripción",
        key: "name",
        type:"textBox"
      },
      {
        label: "Proveedor",
        key: "supplier_name",
        type:"textBox"
      },
      {
        label: "Categoría",
        key: "category",
        type:"textBox"
      },
      {
        label: ["Cantidad", "(Último mes)"],
        key: "quantity",
        type:"number"
      },
      {
        label: "Generado",
        key: "generated",
        type:"number"
      },
      {
        label: "Precio máximo",
        key: "maxPrice",
        type:"number"
      },
      {
        label: "Precio mínimo",
        key: "minPrice",
        type:"number"
      },
      {
        label: "Precio medio",
        key: "averagePrice",
        type:"number"
      },
      {
        label: "Desde",
        key: "createdAt",
        type:"date"
      },
    ],
    docs: [
      {
        label: "ID Transacción",
        key: "documentTitle",
        type:"number"
      },
      {
        label: "Descripción y Categoria",
        key: "description",
        type:"textBox"
      },
      {
        label: "Notas",
        key: "tag",
        type:"textBox"
      },
      {
        label: "Total",
        key: "total",
        type:"number"
      },
      {
        label: "Fecha",
        key: "date",
        type:"date"
      },
      {
        label: "Vencimiento",
        key: "expirationDate",
        type:"number"
      },
      {
        label: "Método de Pago",
        key: "payMethod",
        type:"number"
      },
      {
        label: "Estado",
        key: "state",
        type:"textBox"
      },
      {
        label: "Artículos",
        key: "items",
        type:"textBox"
      },
    ],
  };

  const fetchTableData = async (tableId) => {
    // console.log('recogiendo data de: ', tableId)
    // const res = await dispatch(getTableData(tableId));

    const res = await dispatch(getTableDataFiltered({tableId,
       search: searchTerm,
          limit,
          skip: page * limit,
          sortAlpha: selectedOption["Orden Alfabético"], 
          statusFilter: selectedOption.Estado,
          sortDate: selectedOption.dateFilter,
          sortQuantity: selectedOption.Generado,
          dateOrder: selectedOption.dateOrder
    }));

    // if (res.payload?.data) {
    //   setTableDataMap((prev) => ({
    //     ...prev,
    //     [tableId]: res.payload.data,
    //   }));
    // }
  };

  const getAllTables = async () => {
    let res;
    let tables = [];

    if (id) {
      res = await dispatch(getTableById({ tableId: id }));
      if (res.payload?.table) {
        console.log('esta es la nueva tabla', res?.payload?.table)
        tables = [res.payload.table]; // Convertimos en array para iterar igual
      }
    } else {
      res = await dispatch(getTables());
      if (res.payload?.tables) {
        tables = res.payload.tables;
      }
    }

    if (tables.length > 0) {
      for (let table of tables) {
        await fetchTableData(table._id);
      }
    }
  };

  const [stats, setStats] = useState([
    { title: t('assets'), total: 0 },
    { title: t('contacts'), total: 0 },
    { title: t('docs'), total: 0 },
    { title: t('transactions'), total: 0 },
    {
      title: t('newTable'),
      action: async () => {
        const response = await dispatch(
          createTable({ headers: headersTable, name: "", type: "blank" })
        );
        getAllTables();
        const res = await dispatch(getTablesWithCounts())
        console.log('res', res)
        if (id) {
          navigate('/admin/tables')
        }

      },
    },
  ]);

  //   useEffect(() => {
  //     const fetchStats = async () => {
  //       const response = await fetch(`${apiUrl}/stats`);
  //     }
  //   }, []);
  useEffect(() => {
    getAllTables();
  }, [id]);

  const createData = async (tableId, headers, data, type) => {
    const res = await dispatch(
      createTableData({ tableId, headers, data, type })
    );
    await fetchTableData(tableId);
    const response = await dispatch(refreshTableInfo({ tableId: tableId }))
    console.log('ress', response)
  };

  const renderRow = (row, index, onSelect, orderedColumns) => {
    return (
      <tr key={index}>
        <td>
          <input type="checkbox" />
        </td>
        {orderedColumns.map((column, i) => (
          <td key={i}>{row[column.key] || ""}</td>
        ))}
      </tr>
    );
  };

   const toggleContactSelection = async (contactId) => {
    setSelectedContactIds((prev) =>
      prev.includes(contactId)
        ? prev.filter((id) => id !== contactId)
        : [...prev, contactId]
    );
  };

  const recient = (fecha) => {
    const fechaObj =
      fecha instanceof Date
        ? fecha
        : typeof fecha === "number"
          ? new Date(fecha)
          : new Date(fecha);

    if (isNaN(fechaObj.getTime())) {
      return false;
    }

    const diffMs = Date.now() - fechaObj.getTime();
    return diffMs >= 0 && diffMs < 5 * 60 * 1000;
  };

    const getStateClass = (state) => {
      switch (state.toLowerCase()) {
        case t("paid"):
          return styles.pagada;
        case t("pending"):
          return styles.pendiente;
        case t("unfulfilled"):
          return styles.incumplida;
        case t("defeated"):
          return styles.vencida;
        case t("annulled"):
          return styles.anulada;
        default:
          return "";
      }
    };

  const handleSaveName = async (table) => {
    await dispatch(
      updateTableName({ tableId: table._id, newName: editedTableName })
    );
    getAllTables();
    setEditingTableId(null);
    const response = await dispatch(refreshTableInfo({ tableId: table._id }))
  };
  const typeIcons = {
    contacts: <IconContact />,
    docs: <IconDocument />,
    assets: <IconAsset />,
    blank: <IconTables />,
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target)
      ) {
        setActiveSelectIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const inputRefs = useRef({});

  const [allTransactionsInfo, setAllTransactionsInfo] = useState([])
   const [allAssetsInfo, setAllAssetsInfo] = useState([]);
   const [selectedIds, setSelectedIds] = useState([]);
  const selectAllContacts = (data, tableId) => {
    if (contactSelected?.[tableId]?.length === data?.length) {
      setContactSelected((prevItem) => {
        return {...prevItem, [tableId] :[]}
    })
      setSelectedIds(false);
      setAllAssetsInfo([]);
      setAllTransactionsInfo([])
    } else {
      setSelectedIds(true);
      const allContactIndexes = data.map((contact) => contact._id); 
      setAllAssetsInfo(data);
      setContactSelected((prevItem) => {
        return {...prevItem, [tableId] :allContactIndexes}
    });
    }
  };
  const selectContact = (rowIndex, contact,tableId) => {
    setContactSelected((prevItem) => {
      if(prevItem?.[tableId]?.length > 0){
      if (prevItem[tableId].includes(contact._id)) {
        return {...prevItem, [tableId]:prevItem[tableId].filter((i) => i !== contact._id)}
      } else{
        return {...prevItem, [tableId]:[...prevItem[tableId], contact._id]}
      }
    } else {
        return {...prevItem, [tableId] : [contact._id]};
      }
    });
  };

   const inputRef = useRef(null);

const handleMouseDown = (index,row, tableId) => {
     longPressTriggeredRef.current = false;
    timerRef.current = setTimeout(() => {
      longPressTriggeredRef.current = true;
      inputRef.current?.click()
      selectContact(index, row, tableId);
    }, 600); 
  };

  const handleMouseUp = () => {
    clearTimeout(timerRef.current);
  };


    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const handleActions = (rowIndex, transaction, tableId) => {
      setShowPopup(false)
      setShowPopupNewContact(false)
      setShowPopupNewAsset(false)
      setShowPopupNewTransaction(false);
      setSelectedRowIndex(selectedRowIndex === rowIndex ? null : rowIndex);
      setCurrentTableId(tableId)
    };
  
  
  
    useEffect(() => {
      if (!selectedRowIndex) return;
  
      const onWheel = (e) => {
        setSelectedRowIndex(null);
  
        if (dynamicTableRef.current) {
          dynamicTableRef.current.scrollBy({
            top: e.deltaY,
            behavior: 'auto',
          });
        }
      };
  
      document.addEventListener('wheel', onWheel, {
        passive: true,
        capture: true,
      });
      return () =>
        document.removeEventListener('wheel', onWheel, {
          capture: true,
        });
    }, [selectedRowIndex]);

    const handleDelete = async (tableId, rowId) => {
       await dispatch(deleteRowTable({tableId,rowId} ))
                 dispatch(getTableData(tableId))
      };

       const [showSelectAgent, setShowSelectAgent] = useState(false)
  const [selectedAgent, setSelectedAgent] = useState(false)
  const [talkToAIAssetInfo, setTalkToAIAssetInfo] = useState(null)
  const talkToAi = () => {
    setShowSelectAgent(true)
  }

  useEffect(() => {
    if (selectedAgent?._id) {
      navigate(`/admin/chat/${selectedAgent._id}`, {
        state: {
          rowId: 'Necesito más información sobre el asset @' + talkToAIAssetInfo._id,
          // rowId: 'necesito que me des mas informacion acerda de este asset: ' + talkToAIAssetInfo._id,
          selectedAgentState: selectedAgent,
        },
      });
    }
  }, [selectedAgent._id])

  const handleDoubleAsset = async (tableId, columns, assetData, type) => {
      let newasset = { ...assetData }
      delete newasset._id
      delete newasset.userId
      delete newasset._rev
      delete newasset.createdAt
      delete newasset.updatedAt
      try {

         createData(tableId, columns, newasset, type)
   
      } catch (error) {
        console.error("Error duplicando row:", error);
      }
    }

  

  const contactRenderRow = (row, index, onSelect, orderedColumns, tableId, tableType,columns) => (
    <tr
      key={index}
      className={styles.optionsTr}
      onClick={() => handleClick(row, tableId, tableType)}
      onDoubleClick={() => handleDoubleClick(row,tableId, tableType)}
      onMouseDown={() => handleMouseDown(index,row,tableId)}
      onMouseUp={handleMouseUp}
    >
      <td style={{
        position: selectedRowIndex === index && currentTableId === tableId && 'static'
      }}>
        <div className={styles.optionsTd}>
          <div className={styles.inputWrapperHover}>
            <input
              ref={inputRef}
              type="checkbox"
              name="contactSelected"
              onChange={() => { }}
              onClick={(e) => {
                e.stopPropagation(); 
              }}
              checked={contactSelected?.[tableId]?.includes(row._id) ? true : false}
            />
            <div className={styles.inputContainer} onClick={(e) => {
              e.stopPropagation();
              // toggleContactSelection(row?._id)
              selectContact(index, row,tableId);
              // setAllAssetsInfo((prevState) => {
              //   const exists = prevState.some(
              //     (asset) => asset._id === row._id
              //   );

              //   if (exists) {
              //     return prevState.filter((asset) => asset._id !== row._id);
              //   } else {
              //     return [...prevState, row];
              //   }
              // });
              // handleDivClick()
            }}></div>
          </div>
          <div className={styles.edit}>
            <div
              ref={(el) => {
    if (!popupButtonRef.current[tableId]) {
      popupButtonRef.current[tableId] = {};
    }
   return popupButtonRef.current[tableId][index] = el;
  }}
              onClick={(e) => {
                e.stopPropagation();
                handleActions(index, row, tableId);}}
              className={styles.dotsOptions}
            >
              <img src={optionDots} />
            </div>
          </div>
        </div>
        {selectedRowIndex === index && currentTableId === tableId &&  (
          <div className={styles.optionsPopupContainer}>
             <OptionsPopup
                style={
                  {
                    position: "fixed",
                    top: popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().bottom + 200 > window.innerHeight ? 
                    (popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().top - 180 - (popupButtonRef.current[tableId]?.[index]?.offsetHeight))
                    :
                      ((popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().top +
                        (popupButtonRef.current[tableId]?.[index]?.offsetHeight))),
                    left: popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().left,
                  }
                }
                close={setSelectedRowIndex}
                options={[
                  
                  {
                    label: t("edit"),
                    onClick: (e) => {
                      e.stopPropagation();
                  dispatch(setContact(row));
                       dispatch(
                       setPaginationSlice({ contactLimitSlice: limit, contactPageSlice: page }));
         setShowPopupNewContact(false)
         
         setSelectedRowIndex(null);
        dispatch(setContactTableId(tableId))
        dispatch(setFatherNewContact("tables"));
        navigate(`/admin/contacts/${row._id}`,{ state: { backgroundLocation: location } });
                    },
                  },
                  {
                    label: t("delete"),
                    onClick: (e) => {
                      e.stopPropagation();
                      handleDelete(tableId, row._id);
                      setSelectedRowIndex(null);
                    },
                  },
                  {
                    label: `${t("share")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      // navigator.clipboard.writeText(`${window.location.href}/${row._id}`);
                      navigator.clipboard.writeText(`${(window.location.href).replace("tables", "contacts")}/${row._id}`);
                      setSelectedRowIndex(null);
                    },
                  },
                  {
                    label: `${t("talkToAI")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      talkToAi()
                      setSelectedRowIndex(null);
                      setTalkToAIAssetInfo(row)
                    },
                  },
                  {
                    label: `${t("double")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      handleDoubleAsset(tableId, columns, row, 'contacts')
                      setSelectedRowIndex(null);
                    },
                  },
                ]}
              />
          </div>
        )}
      </td>
      {orderedColumns.filter(col => !col.hidden).map(({ key, createdAt }, index) => {
        const value = key === "paymethod"
          ? row.paymethod?.map((method, i) =>
            <span key={i}>{method.bank} - {method.accountNumber} ({method.currency})</span>
          )
          : key === "createdAt"
            ? row.createdAt ? formatAgoDate({ dateString: row.createdAt, t }) : ""
            : key === "companyPhoneNumber"
              ? `${row?.companyPhoneNumber?.[0]?.code || ""}${row?.companyPhoneNumber?.[0]?.number || ""}`
              : key === "contactName"
                ? <div className={styles.name}>
                  <img src={row.image || emptyImage} alt="" />
                  <div>
                    <span>{row?.contactName}</span>
                    <span>{row?.type}</span>
                  </div>
                </div>
                : key === "transactions"
                  ? <div className={styles.transacciones}>
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(clearDoc());
                        dispatch(
                          setPaginationSlice({
                            contactLimitSlice: limit,
                            contactPageSlice: page,
                          })
                        );
                        handleGetOneContact(row);
                      }}
                    >
                      {t("see")}
                    </a>
                    <AmountTransaction
                      row={row}
                    />
                  </div>
                  : key.split(".").reduce((acc, part) => acc?.[part], row) || "";
        return <td key={key} style={{ background: recient(createdAt) && currentTableNew.find(id => id == tableId ) ? "#e4fff9" : "transparent" }}>{value}</td>;
      })}
    </tr>
  );

  const assetRenderRow = (row, index, onSelect, orderedColumns,tableId,tableType,columns) => (
      <tr
        key={index}
        className={styles.optionsTr}
        onClick={() => handleClick(row, tableId, tableType)}
        onDoubleClick={() => handleDoubleClick(row,tableId,tableType)}
        onMouseDown={() =>  handleMouseDown(index,row,tableId)}
        onMouseUp={handleMouseUp}
      >
        <td style={{
          // position: selectedRowIndex === index && 'static'
          position: selectedRowIndex === index && currentTableId === tableId &&  'static'
        }}>
          <div className={styles.optionsTd}>
            <div className={styles.inputWrapperHover}>
              <input
                ref={inputRef}
                type="checkbox"
                name="contactSelected"
                onChange={() => { }}
                onClick={(e) => {
                  e.stopPropagation();
  
                }}
                checked={contactSelected?.[tableId]?.includes(row._id)}
              />
              <div className={styles.inputContainer} onClick={(e) => {
                e.stopPropagation();
                // toggleClientSelection(row?._id)
                selectContact(index, row,tableId);
                setAllAssetsInfo((prevState) => {
                  const exists = prevState.some(
                    (asset) => asset._id === row._id
                  );
  
                  if (exists) {
                    return prevState.filter((asset) => asset._id !== row._id);
                  } else {
                    return [...prevState, row];
                  }
                });
                // handleDivClick()
              }}></div>
            </div>
  
            <div className={styles.edit}>
              <div
               ref={(el) => {
    if (!popupButtonRef.current[tableId]) {
      popupButtonRef.current[tableId] = {};
    }
   return popupButtonRef.current[tableId][index] = el;
  }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleActions(index, row, tableId);
                }}
                className={styles.dotsOptions}
              >
                <img src={optionDots} alt="options" />
              </div>
            </div>
          </div>
          {selectedRowIndex === index && currentTableId === tableId && (
            <div className={styles.optionsPopupContainer}>
              <OptionsPopup
                style={
                  {
                    position: "fixed",
                    top:
                     popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().bottom + 200 > window.innerHeight ? 
                    (popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().top - 180 - (popupButtonRef.current[tableId]?.[index]?.offsetHeight))
                    :
                      ((popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().top +
                        (popupButtonRef.current[tableId]?.[index]?.offsetHeight))),
                    left: popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().left,
                  }
                }
                close={setSelectedRowIndex}
                options={[
                  
                  {
                    label: t("edit"),
                    onClick: (e) => {
                      e.stopPropagation();
                      // setCreatingBill(false);
                      // setNewContact(false);
                      setSelectedRowIndex(null);
                       dispatch(setAsset(row));
            dispatch(setPaginationSlice({ limitSlice: limit, pageSlice: page }));
            dispatch(setContactTableId(tableId))
                      dispatch(setFatherNewAsset('tables'))
                      navigate(`/admin/assets/${row._id}`, { state: { backgroundLocation: location } });
                    },
                  },
                  {
                    label: t("delete"),
                    onClick: (e) => {
                      e.stopPropagation();
                      handleDelete(tableId, row._id);
                      setSelectedRowIndex(null);
                    },
                  },
                  {
                    label: `${t("share")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      // navigator.clipboard.writeText(`${window.location.href}/${row._id}`);
                      navigator.clipboard.writeText(`${(window.location.href).replace("tables", "assets")}/${row._id}`);
                      setSelectedRowIndex(null);
                    },
                  },
                  {
                    label: `${t("talkToAI")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      talkToAi()
                      setSelectedRowIndex(null);
                      setTalkToAIAssetInfo(row)
                    },
                  },
                  {
                    label: `${t("double")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      handleDoubleAsset(tableId, columns, row, 'assets')
                      setSelectedRowIndex(null);
                    },
                  },
                ]}
              />
            </div>
          )}
        </td>
  
        {orderedColumns.filter(col => !col.hidden).map(({ key, createdAt }, index) => {
          const value = key === "name"
            ? <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <img onError={(e) => {
                e.target.onerror = null;
                e.target.src = imageEmpty;
              }}
                src={row.image || imageEmpty}
                alt="Asset"
                width="30"
                height="30"
              />
              <div>
                {row.name}
                {false && (
                  <>
                    {row.description?.map((desc, index) => (
                      <div key={index} className={index == 0 && styles.titleInfoTd}>
                        {desc}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
            : key === "createdAt"
              ? row.createdAt ? formatAgoDate({ dateString: row.createdAt, t }) : ""
              : key === "category"
                ? row.category ? (
                  <>
                    cc
                   
                  </>
                ) : null
                : key === "supplier_name"
                  ? <>{row.supplier_name} {row.supplier_supplier_address}</>
                  : key === "generated"
                    ? <>{row.generated} {""} {user?.currency}</>
                    : key === "maxPrice"
                      ? <>{row.maxPrice} {""} {user?.currency || "EUR"}</>
                      : key === "minPrice"
                        ? <>{row.minPrice} {""} {user?.currency || "EUR"}</>
                        : key === "averagePrice"
                          ? <>{row.averagePrice} {""} {user?.currency || "EUR"}</>
                          : key.split(".").reduce((acc, part) => acc?.[part], row) || "";
          return <td key={key} style={{ background:  recient(createdAt) && currentTableNew.find(id => id == tableId ) ? "var(--e4fff9-background)" : "transparent" }}>{value}</td>;
        })}
  
      </tr>
    );

    const documentRenderRow = (row, index, onSelect, orderedColumns, tableId, tableType,columns) => (
        <tr
          key={index}
          className={styles.optionsTr}
          onClick={() => handleClick(row, tableId, tableType)}
          onDoubleClick={() => handleDoubleClick(row,tableId, tableType)}
          onMouseDown={() =>  handleMouseDown(index,row,tableId)}
          onMouseUp={handleMouseUp}
        >
          <td style={{position: selectedRowIndex === index && currentTableId === tableId &&  'static'
        }}>
            <div className={styles.optionsTd}>
              <div className={styles.inputWrapperHover}>
                <input
                  ref={inputRef}
                  type="checkbox"
                  name="contactSelected"
                  onChange={() => { }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  checked={contactSelected?.[tableId]?.includes(row._id)}
                />
                <div
                  className={styles.inputContainer}
                  onClick={(e) => {
                    e.stopPropagation();
                    // toggleTransactionSelection(row._id);
                     selectContact(index, row,tableId);
                    // selectContact(row._id);
                    setAllTransactionsInfo((prevState) => {
                      const exists = prevState.some(
                        (asset) => asset._id === row._id
                      );
    
                      if (exists) {
                        return prevState.filter((asset) => asset._id !== row._id);
                      } else {
                        return [...prevState, row];
                      }
                    });
                    // handleDivClick();
                  }}
                ></div>
              </div>
    
              <div className={styles.edit}>
                <div
                 ref={(el) => {
    if (!popupButtonRef.current[tableId]) {
      popupButtonRef.current[tableId] = {};
    }
   return popupButtonRef.current[tableId][index] = el;
  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    // toggleTransactionSelection(row.id);
                    console.log('entra aca')
                    handleActions(index, row, tableId);
                  }}
                  className={styles.dotsOptions}
                >
                  <img src={optionDots} />
                </div>
                {selectedRowIndex === index && currentTableId === tableId && (
                  <div className={styles.optionsPopupContainer}>
                    <OptionsPopup
                style={
                  {
                    position: "fixed",
                    top:
                     popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().bottom + 200 > window.innerHeight ? 
                    (popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().top - 180 - (popupButtonRef.current[tableId]?.[index]?.offsetHeight))
                    :
                      ((popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().top +
                        (popupButtonRef.current[tableId]?.[index]?.offsetHeight))),
                    left: popupButtonRef.current[tableId]?.[index]?.getBoundingClientRect().left,
                  }
                }
                close={setSelectedRowIndex}
                options={[
                  
                  {
                    label: t("edit"),
                    onClick: (e) => {
                      e.stopPropagation();
             setShowPopupNewTransaction(false);
            dispatch(setFatherNewBill("tables"))
            dispatch(setPaginationSlice({ limitSlice: limit, pageSlice: page }));
            navigate(`/admin/docs/${id}/${row._id}`);
                      setSelectedRowIndex(null);
            dispatch(setContactTableId(tableId))
                    },
                  },
                  {
                    label: t("delete"),
                    onClick: (e) => {
                      e.stopPropagation();
                      handleDelete(tableId, row._id);
                      setSelectedRowIndex(null);
                    },
                  },
                  {
                    label: `${t("share")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      // navigator.clipboard.writeText(`${window.location.href}/${row._id}`);
                      navigator.clipboard.writeText(`${(window.location.href).replace("tables", "docs")}/${undefined}/${row._id}`);
                      setSelectedRowIndex(null);
                    },
                  },
                  {
                    label: `${t("talkToAI")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      talkToAi()
                      setSelectedRowIndex(null);
                      setTalkToAIAssetInfo(row)
                    },
                  },
                  {
                    label: `${t("double")}`,
                    onClick: (e) => {
                      e.stopPropagation();
                      handleDoubleAsset(tableId, columns, row, 'docs')
                      setSelectedRowIndex(null);
                    },
                  },
                ]}
              />
                  </div>
                )}
              </div>
            </div>
          </td>
    
          {orderedColumns.map(({ key,createdAt }, index) => {
            const value =
              key === "id" ? (
                <div className={styles.idContainer}>
                  <img src={pdf} className={styles.pdfIcon} />
                  <p> {row._id}</p>
                </div>
              ) : key === "createdAt" ? (
                row.createdAt ? (
                  formatAgoDate({ dateString: row.createdAt, t })
                ) : (
                  ""
                )
              ) : key === "description" ? (
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  {row?.description
                    ? row?.description.map((item, index) => (
                      <span key={index}>{item}</span>
                    ))
                    : t("noDescription")}
                </p>
              ) : key === "tag" ? (
                <div className={styles.tags}>
                  <span className={`${styles.tag} ${styles[row?.tag]}`}></span>
                </div>
              ) : key === "total" ? (
                <>
                  {row?.total} {""} {user?.currency || "EUR"}
                </>
              ) : key === "payMethod" ? (
                <>{row?.payMethod ? row?.payMethod : t("unspecified")}</>
              ) : key === "state" ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <span className={getStateClass(row.state?.[0] || "default")}>
                    &bull;
                  </span>
    
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column-reverse",
                    }}
                  >
                    {Array.isArray(row.state) ? (
                      row.state.map((item, itemIndex) => (
                        <p
                          key={itemIndex}
                          style={{
                            color: itemIndex === 1 ? "blue" : "",
                            fontWeight: itemIndex === 1 ? "600" : "inherit",
                            margin: "0",
                          }}
                          className={getStateClass(row.state[0])}
                        >
                          {item}
                        </p>
                      ))
                    ) : (
                      <p>{row.state}</p>
                    )}
                  </div>
                </div>
              ) : key === "items" ? (
                <div className={styles.actions}>
                  {" "}
                  <div className={styles.transacciones}>
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/admin/panel/${row._id}`);
                      }}
                      href="#"
                    >
                      {t("seeArticles")}
                    </a>
                    <span>(2.345)</span>
                  </div>{" "}
                </div>
              ) : (
                key.split(".").reduce((acc, part) => acc?.[part], row) || ""
              );
    
            return (
              <td
                key={key}
                style={{
                  background:
                  recient(createdAt) && currentTableNew.find(id => id == tableId )
                      ? "var(--e4fff9-background)"
                      : "transparent",
                }}
              >
                {value}
              </td>
            );
          })}
        </tr>
      );

   const toggleSelection = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };


  const fnTableView = async () => { await dispatch(getVariable({ type: 'tableView' })) }

  const setOrderedTable = async (orderedColumns,key,id) => {

    // console.log('esto es  orderedColumns entra en setOrderedTable',orderedColumns)
    // console.log('esto es id entra en setOrderedTable',id)
    if(key){
      await dispatch(createVariable({
                  variableData: {
                    category: "tableView", title: "tableView", type: "tableView",tables :{...tableView.tables,[id]: orderedColumns},
                   parametersTables: { ...tableView.parametersTables, [id]: tableView?.parametersTables?.[id]?.map((item, i) =>
                   item.name === key
              ? (() => {
                  const { hidden, ...rest } = item;
                  return { ...rest, delete: false };
                })()
              : item
          )}
        
                  }
                }))
                 fnTableView()
    } else    {
      await dispatch(createVariable({ variableData: {  category: "tableView", title: "tableView", type: "tableView", tables :{...tableView.tables,[id]: orderedColumns} } }))
     fnTableView()
    }

   
  }
  const setWidthColumn = async (columnWidths, id) => {
    // console.log('esto es columnWidths en  setWidthColumn',columnWidths)
    // console.log('esto es id wn  setWidthColumn',id)
    await dispatch(createVariable({ variableData: { category: "tableView", title: "tableView", type: "tableView", widthTables:  { ...tableView?.widthTables, [id]: columnWidths} } }))
    fnTableView()
  }

  useEffect(() => {
      return () => {
        dispatch(setCurrentTableNew([]))
      }
  }, [])


  useEffect(() => {
    if (!tableView || tableView.length === 0) fnTableView();
  }, []);




  const handleClick = (row, tableId, tableType) => {
      if(!(longPressTriggeredRef.current)){
        if(tableType == "contacts"){
          dispatch(setContact(row));
          dispatch(
            setPaginationSlice({ contactLimitSlice: limit, contactPageSlice: page })
          );
          setCurrentTableId(tableId)
          setCurrentTableType(tableType)
          dispatch(setContactTableId(tableId))
          // setNewContact(false);
          setShowPopupNewContact(true)
          setShowPopupNewAsset(false)
          setShowPopupNewTransaction(false);
          setShowPopup(true)
          dispatch(setFatherNewContact("tables"));
        } else if (tableType == "assets"){
          setCurrentTableId(tableId)
          setCurrentTableType(tableType)
          dispatch(setContactTableId(tableId))
          setShowPopup(true)
          setShowPopupNewTransaction(false);
          setShowPopupNewContact(false)
          setShowPopupNewAsset(true)
                dispatch(setAsset(row));
                dispatch(setPaginationSlice({ limitSlice: limit, pageSlice: page }));
                dispatch(setFatherNewAsset('tables'))
        } else if (tableType == "docs"){
          setCurrentTableId(tableId)
          setCurrentTableType(tableType)
          dispatch(setContactTableId(tableId))
          setShowPopup(true)
          setShowPopupNewAsset(false)
          setShowPopupNewContact(false)
           setShowPopupNewTransaction(true);
           dispatch(setFatherNewBill("tables"))
                dispatch(setPaginationSlice({ limitSlice: limit, pageSlice: page }));
                setDocSelected(row);
        }
    }
    };
    const handleDoubleClick = (row, tableId, tableType) => {
      setShowPopup(false)
      if(tableType == "contacts"){
        dispatch(setContact(row));
        dispatch(
            setPaginationSlice({ contactLimitSlice: limit, contactPageSlice: page })
        );
         setShowPopupNewContact(false)
         
        dispatch(setContactTableId(tableId))
        dispatch(setFatherNewContact("tables"));
        navigate(`/admin/contacts/${row._id}`,{ state: { backgroundLocation: location } });
      } else if (tableType === "assets"){
        setShowPopupNewAsset(false)
            dispatch(setAsset(row));
            dispatch(setPaginationSlice({ limitSlice: limit, pageSlice: page }));
            dispatch(setFatherNewAsset('tables'))
            dispatch(setContactTableId(tableId))
            navigate(`/admin/assets/${row._id}`, { state: { backgroundLocation: location } });
      } else if (tableType === "docs"){
        setShowPopupNewTransaction(false);
            // setShowNewContact(true);
            dispatch(setFatherNewBill("tables"))
            dispatch(setPaginationSlice({ limitSlice: limit, pageSlice: page }));
            navigate(`/admin/docs/${id}/${row._id}`);
      }
    };


     const contactFn = async () => {
            await dispatch(
            getAllContacts({
              search: searchTerm,
              limit,
              skip: page * limit,
              sortAlpha: selectedOption["Orden Alfabético"], 
              statusFilter: selectedOption.Estado,
              sortDate: selectedOption.dateFilter,
              sortQuantity: selectedOption.Generado,
              dateOrder: selectedOption.dateOrder
            })
          );
    
        };

        const [showCreateParameterFromPopup, setShowCreateParameterFromPopup] = useState(false)

        const saveParameter = async(parameter, tableId) => {
if(tableView?.parametersTables?.[tableId]?.length > 0 )  await dispatch(createVariable({variableData:{category: "tableView", title:"tableView", type:"tableView", parametersTables:{...tableView.parametersTables, [tableId]:[parameter,...tableView.parametersTables[tableId] ]}}}))
        else await dispatch(createVariable({variableData:{category: "tableView", title:"tableView", type:"tableView", parametersTables:{...tableView.parametersTables,[tableId]:[parameter ]}}}))
      await dispatch(getVariable({type:'tableView'}))
    }

    const [contactData, setContactData] = useState({})

    useEffect(() => {
  document.body.style.overflow = 'hidden';
  return () => {
    document.body.style.overflow = '';
  };
}, []);

const getTableWithFilter = (tableId) => {
 dispatch(getTableDataFiltered({tableId,
       search: searchTerm,
          limit,
          skip: page * limit,
          sortAlpha: selectedOption["Orden Alfabético"], 
          statusFilter: selectedOption.Estado,
          sortDate: selectedOption.dateFilter,
          sortQuantity: selectedOption.Generado,
          dateOrder: selectedOption.dateOrder
    }));
}

let totalPagination = 0

useEffect(() => {
  const fn = async () => {
        for (let table of tables) {
          await getTableWithFilter(table._id);
        } 
  }
    if (tables.length > 0) fn(tables)
},[limit, page, searchTerm, selectedOption])




const optionsDropdown =[t('#0000ff'), t('#10A37f'),t('#F6851b'),t('#000000'),t('#d4af37')]

const customOptions =[
  {key:"paid", name: t('Paid'),label: <span style={{color:"#009F7A", fontWeight: "bold"}}>{t('Paid')}</span>},
  {key:"pending", name: t('pending') ,label: <span style={{color:"#FF9D00", fontWeight: "bold"}}>{t('pending')}</span>},
   {key:"fail", name: t('defaulted') ,label: <span style={{color:"#FF5500", fontWeight: "bold"}}>{t('defaulted')}</span>},
    {key:"defeated", name: t('due') ,label: <span style={{color:"#C5221F", fontWeight: "bold"}}>{t('due')}</span>},
     {key:"canceled", name: t('voided') ,label: <span style={{color:"#8A0300", fontWeight: "bold"}}>{t('voided')}</span>},
      {key:"draft", name: t('draft') ,label: <span style={{color:"#4F5660", fontWeight: "bold"}}>{t('draft')}</span>},
  ]

  const colors = ["#0000ff",
  "#10A37f",
   "#F6851b",
    "#000000",
     "#d4af37",]

    let index = null
      index = customOptions.findIndex(option => option.key == document?.statusColor)

//  console.log('esto es label',find.label)
const [optionSelected, setOptionSelected] = useState([])
const [tableSelectedColor, setTableSelectedColor] = useState(true)

// console.log('esto es optionSelected', optionSelected)

const handleChangeColor = async (options, table) => {

  setOptionSelected( [...(optionSelected?.filter(option => option.id !== table._id)), {id: table._id, color: options}])

  const resUpdate = await dispatch(
    updateTableType({
      tableId: table._id,
      newType: table.type,
      newHeaders:"",
      color:options
      // ...(newHeaders ? { newHeaders } : {}),
    })
  );
  
  if (resUpdate?.payload?.success) {
    console.log("ya se actualizo");
    await getAllTables(); // refrescar datos
  }
}


  return (
    <div className={`${styles.mainContainer} ${showPopupNewTransaction ? styles.sectionTableMoreBill : showPopup ? styles.sectionTableMore : ""}`} >
    <div className={`${styles.tablesContainer}`}>

      {!id && (
        <div className={styles.headerInfoAccount}>
          {stats.map((stat, index) => {
            const isNewTable = stat.title === t('newTable');
            console.log('esto es isNewTable',isNewTable)
            return (
              <div
                key={index}
                className={`${styles.infoAccount} ${isNewTable ? styles.newTable : ""}`}
                onClick={isNewTable ? stat.action : undefined}
              >
                <h3>{stat.title}</h3>
                <p>{stat.total}</p>
              </div>
            );
          })}
        </div>
      )}
      

      <div className={styles.headerFilter}>
 <ClientsHeader father={'contacts'} 
 customClientsHeader={{flexDirection:"row-reverse",alignItems: "center",  gap: "20px"}}
 customSearchContainer={{width:"100%"}}
            ref={searchInputRef}
            additionalInfo={
              <>
                {totalPaginationTables > 20 && (

                  <PaginationTables
                    totalData={totalPaginationTables}
                    limit={limit}
                    page={page}
                    setPage={setPage}
                    setLimit={setLimit}
                    father={"contact"}
                  />
                )}
              </>
            }
            searchProps={{
              ref: searchInputRef,
              searchTerm: searchTerm,
              setSearchTerm: setSearchTerm,
            }}
            searchChildren={
              <>
                 <Button
                              headerStyle={{
                                all: "unset",
                                background: "#ececf1",
                                color: "var(--_6-color)",
                                padding: "1.5px 4.5px",
                                borderRadius: "4px", fontWeight: 300, cursor: "pointer", fontSize: "12px", marginRight: "4px"
                              }}
                              type="white"
                              action={() => searchInputRef.current.focus()}
                
                            >
                              K
                            </Button>

                <FiltersDropdownContainer
                  setSelectedFilters={setSelectedOption}
                  selectedFilters={selectedOption}
                  options={options}
                />
              </>
            }
          />
      </div>

      {/* tablas */}
      
      <div className={styles.tablesContent}>
     {/* { console.log('esto es tables',tables)} */}
        {tables.map((table, index) => {
          return (
            <div key={index} className={styles.tableWrapper}>
              <div className={styles.tableHeader}>
              {/* {console.log('esto es la ecuacion',optionSelected?.find(option => option.id == table._id))} */}
                {/* {console.log('esto es la ecuacion completa',(optionSelected?.find(option => option.id == table.id))?.color)} */}
                <div>
                <CustomDropdown
                    height="25px"
                    options={optionsDropdown}
                    selectedOption={(optionSelected?.find(option => option.id == table._id))?.color}
                    setSelectedOption={(options) => handleChangeColor(options, table)}
                    father={"docHome"}
                    placeholder={"Seleccione color"}
                    // type={'pagination'}
                    generalStyleFilterSort={{background: "transparent", minWidth: "10px", color:"black"}}
                    // arrowColorCustom={index != null  && colors[index]}
                    arrowSizeCustom={12}
                    stateStripe={false}
                    // generalDropdownHeader={{fontWeight: "bold"}}
                    tableSelectedColor={tableSelectedColor}
                    setTableSelectedColor={setTableSelectedColor}
                  />
                </div>
                <div className={styles.tableNameEditContainer}>
                  <div className={table.color ? styles.iconsTypeTableWhite : styles.iconsTypeTable} style={{background:table.color}}>
                    {typeIcons[table.type] || null}
                  </div>
                  <input
                    ref={(el) => (inputRefs.current[table._id] = el)}
                    className={styles.editInput}
                    value={
                      editingTableId === table._id
                        ? editedTableName
                        : table.name || ""
                    }
                    disabled={editingTableId !== table._id}
                    onChange={(e) => setEditedTableName(e.target.value)}
                    onBlur={ () => handleSaveName(table)}
                    placeholder={t(table.type)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSaveName(table);
                      }
                    }}
                  />

                  <PencilEdit
                    onClick={() => {
                      if (editingTableId === table._id) {
                        setEditingTableId(null);
                         handleSaveName(table);
                      } else {
                        setEditingTableId(table._id);
                        setEditedTableName(table.name || "");
                      }
                      setTimeout(() => {
                        inputRefs.current[table._id]?.focus();
                      }, 0);
                    }}
                    className={styles.editButton}
                  />
                </div>

                <div className={styles.editContainer}>
                  <select
                    value={table.type}
                    onChange={async (e) => {
                      const newType = e.target.value;
                      // Si no seleccionó nada, no hagas nada
                      if (!newType) return;
                      // Si hay headers definidos para ese tipo, los pasamos
                      const newHeaders = headersByType[newType] || headersTable;

                      const resUpdate = await dispatch(
                        updateTableType({
                          tableId: table._id,
                          newType,
                          // ...(newHeaders ? { newHeaders } : {}),
                        })
                      );

                      if (resUpdate?.payload?.success) {
                        console.log("ya se actualizo");
                        await getAllTables(); // refrescar datos
                      }
                    }}
                  >
                    <option value="">{t("selectCategory")}</option>
                    <option value="contacts">{t("contacts")}</option>
                    <option value="assets">{t("asset")}</option>
                    <option value="docs">{t("docs")}</option>
                    <option value="blank">{t("undefined")}</option>
                  </select>

                  <div className={styles.privatePublicButton}>
                    <div> {isChecked ? <TableLockOpen/> : <TableLockClose/> } <span>{t('private')}</span> <OptionsSwitchComponent blackBg={true}
            //  customSlider={{background:"black"}} 
             isChecked={isChecked} setIsChecked={(check) => {setIsChecked2(!isChecked2)
              setIsChecked(!isChecked)
             }} /></div>
                    <div> {isChecked2 ? <TableLockOpen/> : <TableLockClose/> } <span>{t('public')}</span><OptionsSwitchComponent blackBg={true}
            //  customSlider={{background:"black"}} 
             isChecked={isChecked2} setIsChecked={(check) => {setIsChecked2(!isChecked2)
              setIsChecked(!isChecked)
             }} /></div>
                  </div>
                  <Button
                    action={async () => {
                      if (table.type === "contacts") {
                        dispatch(setContact(null));
                        setShowPopupNewContact(false)
                         setShowPopup(false)
                        setActiveTable(table); // Guarda la tabla actual
                        setShowNewContact(true);


                        // dispatch(setContactTableId(table._id));
                      } else if (table.type === "assets") {
                        dispatch(setAsset(null));
                         setShowPopup(false)
                        setShowNewAsset(true);
                        setActiveTable(table); // Guarda la tabla actual
                        // dispatch(setContactTableId(table._id));
                      } else if (table.type === "docs") {
                        setShowPopup(false)
                        setShowNewBill(true);
                        setActiveTable(table); // Guarda la tabla actual
                      } else {
                        createData(table._id, table.headers);
                      }
                    }}
                  >
                    {`${t("new")} ${table.type !== "blank" ? t(table.type) : t("element")} `}
                  </Button>
                  <Button
                    type="white"
                    action={() => {
                      setActiveSelectIndex(
                        index === activeSelectIndex ? null : index
                      );
                    }}
                    headerStyle={{
                      padding: "12px 0px",
                      background: "#ECECF1",
                      borderRadius: "12px",
                    }}
                  >
                    <HorizontalDots className={styles.dotsEdit} />
                  </Button>

                  {activeSelectIndex === index && (
                    <div className={styles.selectContainer} ref={selectRef}>
                      <div
                        onClick={async () => {
                          const res = await dispatch(
                            deleteTable({ tableId: table._id })
                          );
                          dispatch(
                            createVariable({
                              variableData: {
                                category: "tableView",
                                title: "tableView",
                                type: "tableView",
                                tables: Object.entries(tableView.tables)
                                  .filter(([id, _]) => id !== table._id)
                                  .reduce((acc, [id, data]) => {
                                    acc[id] = data;
                                    return acc;
                                  }, {}),
                                parametersTables: Object.entries(
                                  tableView.parametersTables
                                )
                                  .filter(([id, _]) => id !== table._id)
                                  .reduce((acc, [id, data]) => {
                                    acc[id] = data;
                                    return acc;
                                  }, {}),
                                widthTables: Object.entries(
                                  tableView.widthTables
                                )
                                  .filter(([id, _]) => id !== table._id)
                                  .reduce((acc, [id, data]) => {
                                    acc[id] = data;
                                    return acc;
                                  }, {}),
                              },
                            })
                          );
                          console.log("eliminando", res);
                          setActiveSelectIndex(null);
                          if (id) {
                            navigate("/admin/tables");
                          }
                        }}
                      >
                        {t("delete")}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {table.type === "contacts" ? (
                <DynamicTable
                  columns={table.headers}
                  ref={dynamicTableRef}
                  data={tableDataMap[table._id] || []}
                  renderRow={contactRenderRow}
                  selectedIds={contactSelected?.[table._id]}
                  onSelectAll={selectAllContacts}
                  onSelect={toggleSelection}
                  setOrderedTable={setOrderedTable}
                  fatherOrder={`${table._id}`}
                  orderedColumnsInitial={table.headers}
                  setWidthColumn={setWidthColumn}
                  fatherWidth={`${table._id}`}
                  tables={true}
                  recient={recient}
                  tableId={table._id}
                  tableType={table.type}
                />
              ) : table.type === "assets" ? (
                <DynamicTable
                  recient={recient}
                  columns={table.headers}
                  ref={dynamicTableRef}
                  data={tableDataMap[table._id] || []}
                  renderRow={assetRenderRow}
                  selectedIds={contactSelected?.[table._id]}
                  onSelectAll={selectAllContacts}
                  onSelect={toggleSelection}
                  setOrderedTable={setOrderedTable}
                  fatherOrder={`${table._id}`}
                  orderedColumnsInitial={table.headers}
                  setWidthColumn={setWidthColumn}
                  fatherWidth={`${table._id}`}
                  tables={true}
                  tableId={table._id}
                  tableType={table.type}
                />
              ) : table.type === "docs" ? (
                <DynamicTable
                  recient={recient}
                  columns={table.headers}
                  ref={dynamicTableRef}
                  data={tableDataMap[table._id] || []}
                  renderRow={documentRenderRow}
                  selectedIds={contactSelected?.[table._id]}
                  onSelectAll={selectAllContacts}
                  onSelect={toggleSelection}
                  setOrderedTable={setOrderedTable}
                  fatherOrder={`${table._id}`}
                  orderedColumnsInitial={table.headers}
                  setWidthColumn={setWidthColumn}
                  fatherWidth={`${table._id}`}
                  tables={true}
                  tableId={table._id}
                  tableType={table.type}
                />
              ) : (
                ""
              )}

              {/* <table className={styles.table}>
                <thead>
                  <tr>
                    <th></th>
                    {table.headers.map((col, idx) => (
                      <th key={idx}>
                        {Array.isArray(col.label)
                          ? col.label.join(" ")
                          : col.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(tableDataMap[table._id] || [])
                    .filter((row) => row.type === table.type) // <-- filtro agregado
                    .map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        <td>
                          <input type="checkbox" />
                        </td>
                        {table.headers.map((col, colIndex) => (
                          <td key={colIndex}>
                            {row[col.key] || (
                              <span className={styles.placeholderTable}>
                                {row[col.key]}
                              </span>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table> */}
            </div>
          );
        })}

      </div>
      {showNewContact && (
        <>
        {/* {console.log('esto es activeTable',activeTable)} */}
          <NewContact
            setShowNewContact={setShowNewContact}
            newContactProp={true}
            //   selectedContact={selectedContact}
            //   setShowNewBill={setShowNewBill}
            isGlobalTables={true}
            createData={createData}
            tableType={activeTable.type}
            tableId={activeTable._id}
            headers={activeTable.headers}
          />
        </>
      )}
      {newAsset && (
        <NewAsset
          setShowNewClient={setShowNewAsset}
          setShowAddTags={setShowAddTags}
          setSelectedTags={setSelectedTags}
          selectedTags={selectedTags}
          setTags={setTags}
          tags={tags}
          creatingBill={false}
          setShowNewAsset={setShowNewAsset}
          setShowNewContact={setShowNewContact}
          showNewContact={showNewContact}
          showAddTags={showAddTags}
          isGlobalTables={true}
          createData={createData}
          tableType={activeTable.type}
          tableId={activeTable._id}
          headers={activeTable.headers}
          fn={() => { }}
        />
      )}

      {showNewBill && (
        <NewBIll
          setShowNewBill={setShowNewBill}
          getDocuments={() => { }}
          isGlobalTables={true}
          createData={createData}
          tableType={activeTable.type}
          tableId={activeTable._id}
          headers={activeTable.headers}
        />
      )}
    </div>
<div style={{position:"relative"}}>


     <div className={`${styles.popupContainer} ${showPopupNewContact ? styles.popupContainerVisible : ""}`} style={{height:"93vh"}}>
                  <NewContact
                    type='popup'
                    customStyleOverlay={{width:"100%", height:"100%"}}
                    customStyleNewContactContainer={{position:"relative", height:"100%"}}
                    customStylePopupNewContaier={{  flexDirection: "column",alignItems: "center"}}
                    customStyleContactinfo={{flexDirection: "column",alignItems: "center"}}
                    customStyleColumnRightContactInfo={{alignItems: "center"}}
                    customStyleModalTemplate={{height:"100%"}}
                    customStyleModalTemplateHeader={{padding: "2px 5px 0px"}}
                    customStyleLeftSide={{maxWidth: "96%", height:"min-content",width: "96%",  padding: "0px 20px"}}
                    customStyleContentContainer={{padding:"0px", height:"99%",marginTop: "-15px",pointerEvents: "none"}}
                    customStyleButtonContainer={{width:"100%"}}
                    customStyleButtonHeader={{width: "100%",  margin: "10px"}}
                    customStyleColumnDirection={{flexDirection:"column"}}
                    customStyleNavigationPopupsContainer={{overflow: "visible", height:"100%"}}
                    customStyleSectionContact={{display:"flex",flexDirection:"column",justifyContent: "start",alignItems: "start"}}
    
                    fnContact={contactFn}
                    setShowNewContact={(boolean) => {
                      setShowPopup(boolean)
                      setShowPopupNewContact(boolean)}}
                    // newContactProp={newContactProp}
                    // selectedContact={selectedContact}
                    // setShowNewBill={setShowNewBill}
                    setShowPopupNewContact={(boolean) => {
                      setShowPopup(boolean)
                      setShowPopupNewContact(boolean)}}
                    setShowCreateParameterFromPopup={setShowCreateParameterFromPopup}
                    tableId={currentTableId}
                    tableType={currentTableType}
                  />
                </div>

                <div className={`${styles.popupContainer} ${showPopupNewAsset ? styles.popupContainerVisible : ""}`} style={{ height: "93vh" }}>
          <NewAsset
            typeContainer='popup'
            customStyleOverlay={{ width: "100%", height: "100%" }}
            customStyleNewContactContainer={{ position: "relative", height: "100%", width: "100%" }}
            // customStyleNewContactContainer={{ height: "100%", width: "100%" }}
            customStylePopupNewContaier={{ flexDirection: "column", alignItems: "center" }}
            customStyleContactinfo={{ flexDirection: "column", alignItems: "center" }}
            customStyleColumnRightContactInfo={{ alignItems: "center" }}
            customStyleModalTemplate={{ height: "100%" }}
            customStyleModalTemplateHeader={{ padding: "2px 5px 0px"}}
            customStyleLeftSide={{ maxWidth: "96%",height:"min-content",}}
            customStyleContentContainer={{ padding:"0px", height:"99%",marginTop: "-15px",pointerEvents: "none" }}
            customStyleButtonContainer={{ width: "100%" }}
            customStyleButtonHeader={{ width: "100%", margin: "10px" }}
            customStyleColumnDirection={{ flexDirection: "column" }}
            customStyleNavigationPopupsContainer={{overflow: "visible", height:"100%"}}
            customStyleFormNewProduct={{overflow:"unset"}}
             customStyleSectionContact={{padding:"10px"}}

            setShowNewClient={(boolean) => {
                      setShowPopup(boolean)
                      setShowPopupNewAsset(boolean)}}
            setShowPopupNewAsset={(boolean) => {
                      setShowPopup(boolean)
                      setShowPopupNewAsset(boolean)}}
            // setShowAddTags={setShowAddTags}
            // setSelectedTags={setSelectedTags}
            // selectedTags={selectedTags}
            // setTags={setTags}
            // tags={tags}
            // creatingBill={creatingBill}
            // setShowNewAsset={setShowNewClient}
            // setShowNewContact={setShowNewContact}
            // showNewContact={showNewContact}
            // showAddTags={showAddTags}
            // limit={limit}
            // page={page}
            // searchTerm={searchTerm}
            // fn={fn}
            setShowCreateParameterFromPopup={setShowCreateParameterFromPopup}
            tableId={currentTableId}
            tableType={currentTableType}
          />
        </div>
        <div
          className={`${styles.popupContainer} ${showPopupNewTransaction ? styles.popupContainerVisible : ""}`}
          style={{ height: "93vh" }}
        >
          <NewBIll
            typeContainer="popup"
            customStyleOverlay={{ width: "100%", height: "100%" }}
            customStyleNewContactContainer={{
              position: "relative",
              height: "100%",
            }}
            customStylePopupNewContaier={{
              flexDirection: "column",
              alignItems: "center",
            }}
            customStyleContactinfo={{
              flexDirection: "column",
              alignItems: "center",
            }}
            customStyleModalTemplate={{ height: "100%" }}
            customStyleModalTemplateHeader={{ padding: "15px 38px 15px 25px" }}
            customStyleLeftSide={{
              width: "100%",
              height: "auto",
              display: "flex",
              justifyContent: "center",
              maxWidth: "86%",
            }}
            customStyleContentContainer={{ padding: "0px", height: "90%" }}
            customStyleColumnRightContactInfo={{ padding: "0px" }}
            customStyleButtonContainer={{ width: "100%" }}
            customStyleButtonHeader={{ width: "100%", margin: "10px" }}
            customStyleColumnDirection={{ flexDirection: "column" }}
            customStyleNavigationPopupsContainer={{
              overflow: "visible",
              height: "100%",
            }}
            fatherDoc={docSelected}
            setShowNewBill={(boolean) => {
                      setShowPopup(boolean)
                      setShowPopupNewTransaction(boolean)}}
            // getDocuments={getDocuments}
            tableId={currentTableId}
            tableType={currentTableType}
          />
        </div>
</div>
                
                {showCreateParameterFromPopup && (
                                  <CreateParameterPopup
                                  saveParameter={saveParameter}
                                    setShowCreateParameter={setShowCreateParameterFromPopup}
                                    setState={setContactData}
                                    tableId={currentTableId}
                                  />
                                )}

                                {showSelectAgent && (
                                        <SelectAgentModal
                                          setState={setShowSelectAgent}
                                          // setSelectedAgent={setSelectedAgent}
                                        />
                                      )}
    </div>
  );
};

export default Tables;
